const RELOAD_GUARD_KEY = 'yumnia_stale_chunk_reload_target'

const STALE_CHUNK_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload CSS/i,
  /error loading dynamically imported module/i,
  /Couldn't resolve component default/i,
]

export function isStaleChunkError (error) {
  const message = typeof error === 'string' ? error : error?.message
  return !!message && STALE_CHUNK_PATTERNS.some(pattern => pattern.test(message))
}

function setReloadGuard (targetPath) {
  try {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY)) return false
    sessionStorage.setItem(RELOAD_GUARD_KEY, targetPath)
  } catch (_error) {
    return false
  }
  return true
}

export function clearStaleChunkReloadGuard () {
  try {
    sessionStorage.removeItem(RELOAD_GUARD_KEY)
  } catch (_error) {
    // A blocked sessionStorage also prevents recovery, so there is nothing to clear.
  }
}

// A tab opened before a deploy still points at hashed assets that no longer
// exist. One reload fetches the fresh index.html; the guard stays set until the
// target route loads successfully, so a real outage cannot cause a reload loop.
export function recoverFromStaleChunk (targetPath) {
  const currentPath = window.location.pathname + window.location.search + window.location.hash
  const reloadTarget = targetPath || currentPath
  if (!setReloadGuard(reloadTarget)) return false

  if (targetPath && targetPath !== currentPath) {
    window.location.assign(targetPath)
  } else {
    window.location.reload()
  }
  return true
}

export function installStaleChunkRecovery (router) {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    setTimeout(() => recoverFromStaleChunk(), 0)
  })

  router.onError((error, to) => {
    if (isStaleChunkError(error)) recoverFromStaleChunk(to?.fullPath)
  })

  router.isReady().then(clearStaleChunkReloadGuard).catch(() => {})
}
